import { Component, Input, OnInit } from '@angular/core';
import { FieldMetaData, PersonRolleCountListEntryMeta } from '../../../../core/gb-api';
import AccessEnum = FieldMetaData.AccessEnum;

@Component({
  selector: 'cap-person-rolle-count',
  templateUrl: './person-rolle-count.component.html',
  styleUrls: ['./person-rolle-count.component.scss']
})
export class PersonRolleCountComponent implements OnInit {
  @Input()
  personRolleCount: PersonRolleCountListEntryMeta;
  @Input()
  fieldMetaData: FieldMetaData;

  constructor() {}

  ngOnInit() {}

  canRead(): boolean {
    return this.fieldMetaData.access !== AccessEnum.NONE;
  }

  canReadHistorisch(): boolean {
    return this.personRolleCount && this.personRolleCount.mHistorischCount.access !== AccessEnum.NONE;
  }

  getRechtsgueltigCount(): string | number {
    if (this.canRead()) {
      return this.personRolleCount.rechtsgueltigCount > 0 ? this.personRolleCount.rechtsgueltigCount : '-';
    } else {
      return 'n.a.';
    }
  }

  getHistorischCount(): string | number {
    if (this.canReadHistorisch()) {
      return this.personRolleCount.historischCount > 0 ? this.personRolleCount.historischCount : '-';
    } else {
      return 'n.a.';
    }
  }
}
